import React from "react";

export default function TextInput({ label, handleTextInput }) {
	return (
		<div class="input-group">
			<div class="input-group-prepend">
				<span class="input-group-text" id="inputGroup-sizing-sm">
					{label}
				</span>
			</div>
			<input
				type="text"
				class="form-control"
				aria-label="Sizing example input"
				aria-describedby="inputGroup-sizing-sm"
				onChange={(e) => handleTextInput(e.target.value)}
			/>
		</div>
	);
}
